import { AnyAction } from 'redux';
import { ActionTypes } from '../actions/ActionTypes';
import { ResourceListOfWorkflowOptionApprovalDto } from 'src/services/Client';

export interface IApprovalsState {
  approvals?: ResourceListOfWorkflowOptionApprovalDto;
}

const INITIAL_STATE: IApprovalsState = {
  approvals: undefined,
};

export const approvalsReducer = (
  state: IApprovalsState = INITIAL_STATE,
  action: AnyAction
): IApprovalsState => {
  switch (action.type) {
    case ActionTypes.RECEIVE_APPROVAL_LIST:
      return {
        ...state,
        approvals: action.data,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/approvalsReducer.ts